import Api from 'utils/api'

export const fetchInterview = ({ uuid }: { uuid: string }) => Api.get(['interviews', uuid])

export const patchEvaluation = ({ evaluationData, status, id }: {
  evaluationData: Record<string, unknown>
  status: string
  id: number | string
}) =>
  Api.patch(['interviewevaluations', id], {
    evaluation_data: evaluationData,
    status,
  })

export const deleteEvaluator = ({ uuid }: { uuid: string }) =>
  Api.delete(['interviewevaluations', uuid])

export const saveEvaluator = ({ email, jobInterview, name }: {
  email: string
  jobInterview: string
  name: string
}) =>
  Api.post('interviewevaluations', {
    email,
    job_interview: jobInterview,
    name,
  })
